/**
 * Stale or truncated JS chunks after a deploy fail in browser-specific ways.
 * ErrorBoundary recovers these with a hard navigation; keep this list in sync
 * with `ignoreErrors` in `instrument.ts`.
 */
export function isRecoverableChunkError(
  error: { name?: string; message?: string } | null | undefined,
): boolean {
  const message = error?.message?.toLowerCase() || "";
  return (
    message.includes("importing a module") ||
    message.includes("failed to fetch dynamically imported module") ||
    // Safari reports a failed dynamic import of a stale chunk as a MIME-type
    // error because the SPA fallback serves index.html for the missing .js file.
    message.includes("is not a valid javascript mime type") ||
    // Safari reports a truncated/partially-cached chunk as a SyntaxError
    // with no useful stack (GOFRANCHISE-WEB-B1).
    message.includes("unexpected end of script") ||
    // Chrome reports the same truncated-chunk parse two ways: the bare
    // SyntaxError (GOFRANCHISE-WEB-AZ) and the appendChild wrapper (B0).
    // Exact match so we do not treat `Unexpected end of JSON input` as a chunk miss.
    message === "unexpected end of input" ||
    message.includes("failed to execute 'appendchild' on 'node': unexpected end of input") ||
    error?.name === "ChunkLoadError"
  );
}
